import {
  GET_REGISTRATION_LIST, GET__REGISTRATION_DETAILS,
} from "../types";

const initialState = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};

export default function registrationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REGISTRATION_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case GET__REGISTRATION_DETAILS:
      return {
        ...state,
        create: false,
        detail: true,
        response: action.payload,
      };

    default:
      return state;
  }
}
